import {
  Box,
  Button,
  Container,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import { MdClose } from "react-icons/md";
import * as yup from "yup";
import InputContainer from "../../../components/InputContainer";
import ModalHeader from "../../../components/ModalHeader";
import Interactive from "./Interactive";
import LivePoll from "./LivePoll";
import Questionnaire from "./Questionnaire";
import Settings from "./Settings";
import SpinnerFrom from "./SpinnerFrom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1,
  maxWidth: 539,
  bgcolor: "#F4F5F7",
  boxShadow: 24,
  borderRadius: "24px",
  overflow: "hidden",
  border: 0,
  pb: 4,
  maxHeight: {
    lg: "80vh",
    md: "85vh",
    sm: "90vh",
  },
};

const validationSchema = yup.object({});

const InteractiveFrom = ({ open, handleClose, feature }) => {
  const formik = useFormik({
    initialValues: {
      typeId: open?.features.typeId || "1",
      entityId: open?.features.entityId || "",
      videoPause: open?.features.videoPause || false,
      duration: open?.features.duration || "",
      position: open?.features.position || "",
      startTime: open?.features.startTime || "",
    },

    validationSchema: validationSchema,
    onSubmit: (vals) => {
      vals.typeId = Number(vals.typeId);
      vals.position = Number(vals.position);
      console.log(vals);
      feature.unshift(vals);
      handleClose();
    },
  });

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper sx={style}>
          <IconButton
            sx={{
              color: "primary.contrastText",
              position: "absolute",
              top: 20,
              left: 25,
            }}
            onClick={handleClose}
            size="small"
          >
            <MdClose size={24} />
          </IconButton>
          <ModalHeader primaryText="Add" secondaryText="Interactive" />
          <Box sx={{ px: 2 }}></Box>
          <Container maxWidth={"xl"} sx={{ overflow: "auto", height: "60vh" }}>
            <form onSubmit={formik.handleSubmit} style={{ width: "100%" }}>
              <RadioGroup
                name="typeId"
                value={formik.values.typeId}
                row
                onChange={(value, e) => {
                  formik.handleChange(value);
                }}
                sx={{ display: "flex", pt: 3, width: 1 }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12}>
                    <Typography fontWeight={700} variant="body1">
                      Choose the feature that will appear in this second.
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    sx={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      px: 2,
                    }}
                  >
                    <FormControlLabel
                      value={Number(1)}
                      control={<Radio color="info" />}
                      label={
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Typography variant="subtitle2" color={"#5B5B5B"}>
                            Questionnaire
                          </Typography>
                        </Box>
                      }
                    />

                    <FormControlLabel
                      value={Number(2)}
                      control={<Radio color="info" />}
                      label={
                        <Box>
                          <Typography variant="subtitle2" color={"#5B5B5B"}>
                            Spinner
                          </Typography>
                        </Box>
                      }
                    />

                    <FormControlLabel
                      value={Number(3)}
                      control={<Radio color="info" />}
                      label={
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Typography variant="subtitle2" color={"#5B5B5B"}>
                            Interactive
                          </Typography>
                        </Box>
                      }
                    />
                    <FormControlLabel
                      value={Number(4)}
                      control={<Radio color="info" />}
                      label={
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Typography variant="subtitle2" color={"#5B5B5B"}>
                            live poll
                          </Typography>
                        </Box>
                      }
                    />
                  </Grid>
                </Grid>
              </RadioGroup>

              {formik.values.typeId === "1" && (
                <Questionnaire formik={formik} />
              )}
              {formik.values.typeId === "2" && <SpinnerFrom formik={formik} />}
              {formik.values.typeId === "3" && <Interactive formik={formik} />}
              {formik.values.typeId === "4" && <LivePoll formik={formik} />}

              <InputContainer
                title={"Choose the second the feature will appear"}
                sx={{ my: 1 }}
              >
                <TextField
                  fullWidth
                  name="startTime"
                  type="number"
                  value={formik.values.startTime}
                  onChange={formik.handleChange}
                  placeholder={"Enter Video startTime"}
                  variant="standard"
                  error={
                    formik.touched.startTime && Boolean(formik.errors.startTime)
                  }
                  helperText={
                    formik.touched.startTime && formik.errors.startTime
                  }
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </InputContainer>
              <Settings formik={formik} />
              <Box sx={{ width: 1, mt: 2, mb: 1 }}>
                <Button
                  sx={{ p: 1, width: "30%" }}
                  variant="outlined"
                  color="error"
                  onClick={handleClose}
                >
                  Back
                </Button>
                <Button
                  type="submit"
                  sx={{ p: 1, mx: 2, width: "30%" }}
                  variant="contained"
                  color="error"
                >
                  <Typography color={"white"}>Done</Typography>
                </Button>
              </Box>
            </form>
          </Container>
        </Paper>
      </Modal>
    </>
  );
};

export default InteractiveFrom;
